import React from "react";

import { Autocomplete, TextField, TextFieldProps } from "@mui/material";

export interface ListAutocompleteProps {
  options: string[];
  onChange: (value: string) => void;
  sx?: TextFieldProps["sx"];
  charName: string;
  defaultValue?: string;
  value?: string;
  disabled?: boolean;
}

export const ListAutocomplete: React.FC<ListAutocompleteProps> = ({
  options,
  onChange,
  charName,
  defaultValue,
  value,
  disabled,
  ...props
}) => {
  return (
    <Autocomplete
      fullWidth
      options={options}
      value={value || ""}
      defaultValue={defaultValue}
      disableClearable
      disabled={disabled}
      renderInput={(params) => <TextField {...params} label={charName} {...props} />}
      onChange={(_, value) => onChange(value || "")}
      {...props}
    />
  );
};
